import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { useCikContext } from '../../Context/CentralIndustrisContaxtProvider';
import contactBg from '../../assets/images/contactbg.png';
import './Contact.css';

function Contact() {
  const { setNotiStatus, setNotiContent, setNotiError } = useCikContext();
  const formRef = useRef();

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    street: '',
    city: '',
    zip: '',
    date: '',
    consent: false
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({ 
      ...prev, 
      [name]: type === 'checkbox' ? checked : value 
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { firstName, lastName, email, phone, street, city, zip, date, consent } = formData;

    if (!consent) {
      setNotiContent("Please consent to text messages to proceed.");
      setNotiError(true);
      setNotiStatus(true);
      setTimeout(() => setNotiStatus(false), 4000);
      return;
    }

    if (firstName && lastName && email && phone && street && city && zip && date) {
      setNotiContent("Inspection Booked Successfully!");
      setNotiStatus(true);
      setTimeout(() => setNotiStatus(false), 4000);
      setFormData({ 
        firstName: '', lastName: '', email: '', phone: '', 
        street: '', city: '', zip: '', date: '', consent: false 
      });
    } else {
      setNotiContent("Please fill all required fields.");
      setNotiError(true);
      setNotiStatus(true);
      setTimeout(() => setNotiStatus(false), 4000);
    }
  };

  return (
    <section className="contact-premium-section" id="Contact">
      <div className="container">
        <div 
          className="contact-premium__box" 
          style={{ backgroundImage: `url(${contactBg})` }}
        >
          <div className="contact-premium__overlay" />
          
          <div className="contact-premium__inner">
            <div className="contact-premium__row">
              
              {/* ── Left Column: Form Card ────────────────── */}
              <motion.div 
                className="contact-card"
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                <h2 className="contact-card__title">
                  Book a Roof Inspection <br /> 
                  <span>& Receive a Free Estimate</span>
                </h2>

                <form ref={formRef} className="contact-card__form" onSubmit={handleSubmit}>
                  <div className="contact-card__grid">
                    <input
                      name="firstName"
                      placeholder="First Name"
                      value={formData.firstName}
                      onChange={handleInputChange}
                      required
                    />
                    <input
                      name="lastName"
                      placeholder="Last Name"
                      value={formData.lastName}
                      onChange={handleInputChange}
                      required
                    />
                    <input
                      name="email"
                      type="email"
                      placeholder="Email Address"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                    />
                    <input
                      name="phone"
                      placeholder="Phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      required
                    />
                    <input
                      name="street"
                      placeholder="Street"
                      value={formData.street}
                      onChange={handleInputChange}
                      required
                    />
                    <input
                      name="city"
                      placeholder="City"
                      value={formData.city}
                      onChange={handleInputChange}
                      required
                    />
                    <div className="contact-card__select-wrapper">
                      <select
                        name="date"
                        value={formData.date}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="" disabled>Select Date</option>
                        <option value="ASAP">As soon as possible</option>
                        <option value="This Week">Within this week</option>
                        <option value="Next Week">Next week</option>
                        <option value="Flexible">I'm flexible</option>
                      </select>
                    </div>
                    <input
                      name="zip"
                      placeholder="Zip/Postal Code"
                      value={formData.zip}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div className="contact-card__consent">
                    <input
                      type="checkbox"
                      id="consent-check"
                      name="consent"
                      checked={formData.consent}
                      onChange={handleInputChange}
                    />
                    <label htmlFor="consent-check">
                      I consent to receiving text messages regarding my inquiry. 
                      Message and data rates may apply.
                    </label>
                  </div>

                  <button type="submit" className="contact-card__btn-pill">
                    Get A Free Roof Inspection
                  </button>
                </form>
              </motion.div>

              {/* ── Right Column: Info Panel ────────────── */}
              <motion.div 
                className="contact-info-panel"
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.1 }}
              >
                <h1 className="contact-info-panel__big-title">Let’s <br /> Connect</h1>

                <div className="contact-info-details-box">
                  <div className="contact-info-details-box__header">
                    <h3>Contact Info</h3>
                    <div className="divider-line" />
                  </div>
                  
                  <div className="contact-info-row">
                    <label>Phone</label>
                    <p>+94 76 360 7727</p>
                  </div>

                  <div className="contact-info-row">
                    <label>Email</label>
                    <p>centralind64@gmail.com</p>
                  </div>

                  <div className="contact-info-row">
                    <label>Service Area</label>
                    <p>Matale, Kandy and 50-mile radius</p>
                  </div>
                </div>
              </motion.div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;